import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { CONSENT_CHANGE_EVENT, setConsent } from "@/analytics/ga4";

export function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const storedConsent = localStorage.getItem('cookieConsent');
    if (storedConsent === null) {
      setShowBanner(true);
      return;
    }

    setShowBanner(false);
  }, []);

  const handleAccept = async () => {
    localStorage.setItem('cookieConsent', 'true');
    setShowBanner(false);
    window.dispatchEvent(new CustomEvent(CONSENT_CHANGE_EVENT, { detail: { analytics: true } }));

    try {
      await setConsent({ analytics: true });
    } catch (error) {
      console.error('Failed to enable analytics after consent:', error);
    }
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'false');
    setShowBanner(false);
    window.dispatchEvent(new CustomEvent(CONSENT_CHANGE_EVENT, { detail: { analytics: false } }));
    void setConsent({ analytics: false });
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t shadow-lg" style={{ backgroundColor: '#ffffff', borderColor: '#e5e7eb' }}>
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1">
            <p className="text-sm text-muted-foreground">
              We use cookies only for analytics to understand site usage and improve your experience. You can decline and the site will work perfectly.{" "}
              <a href="/privacy" className="underline hover:text-foreground">Privacy Policy</a>
            </p>
          </div>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={handleDecline}
              className="text-xs"
            >
              Decline
            </Button>
            <Button
              size="sm"
              onClick={handleAccept}
              className="bg-[#E10600] hover:bg-[#c50500] text-white text-xs"
            >
              Accept
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
